import { render, staticRenderFns } from "./fourththird.vue?vue&type=template&id=2035211a&"
import script from "./fourththird.vue?vue&type=script&lang=js&"
export * from "./fourththird.vue?vue&type=script&lang=js&"
import style0 from "./fourththird.vue?vue&type=style&index=0&id=2035211a&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2035211a')) {
      api.createRecord('2035211a', component.options)
    } else {
      api.reload('2035211a', component.options)
    }
    module.hot.accept("./fourththird.vue?vue&type=template&id=2035211a&", function () {
      api.rerender('2035211a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fourth/fourththird.vue"
export default component.exports